import './Badge.scss';

import React, { ReactNode } from 'react';
import classNames from 'classnames';

export enum BadgeStyle {
  Black = 'black',
  Blue = 'blue',
  Purple = 'purple',
  Yellow = 'yellow',
  Green = 'green',
  Orange = 'orange',
  Grey = 'grey',
  Red = 'red',
}

interface IProps {
  children: ReactNode | ReactNode[];
  style?: BadgeStyle;
  fullWidth?: boolean;
  autoSize?: boolean;
  onClick?: () => void;
}

function Badge({ children, fullWidth, autoSize, onClick, style = BadgeStyle.Black }: IProps) {
  const className = classNames(`modBadge modBadge--${style}`, {
    'modBadge--full-width': fullWidth,
    'modBadge--auto-size': autoSize,
    'modBadge--button': onClick,
  });
  return onClick ? (
    <button className={className} onClick={onClick}>
      {children}
    </button>
  ) : (
    <div className={className}>{children}</div>
  );
}

export default Badge;
